import { render, staticRenderFns } from "./SpeechView.vue?vue&type=template&id=270cf91a&"
import script from "./SpeechView.vue?vue&type=script&lang=js&"
export * from "./SpeechView.vue?vue&type=script&lang=js&"
import style0 from "./SpeechView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports